import Immutable from 'immutable';
import { Markup, RawMarkup } from 'records/Markup';
import { PageId } from 'records/Page';
import { RawRFI, RFI } from 'records/RFI';
import { SheetId } from 'records/Sheet';

export interface RawPostRFI {
  type: string;
  markup: RawMarkup | null; // This should probably just be a Markup Record...
  originalMarkup: RawMarkup | null; // used for returning to the original state.
  rfi: RawRFI;
  sheetid: SheetId;
  pageid: PageId;
  updatingMarkup: boolean;
}

export interface PostRFIData {
  type: string;
  markup: Markup | null;
  originalMarkup: Markup | null;
  rfi: RFI;
  sheetid: SheetId;
  pageid: PageId;
  updatingMarkup: boolean;
  removingMarkup: boolean;
}

const defaultValues: PostRFIData = {
  type: 'PostRFI',
  markup: null,
  originalMarkup: null,
  rfi: new RFI(),
  sheetid: '',
  pageid: '',
  updatingMarkup: false,
  removingMarkup: false,
};

export const PostRFIFactory = Immutable.Record(defaultValues, 'PostRFI');

export class PostRFI extends PostRFIFactory {
  static deserialize(rawPostRFI: RawPostRFI): PostRFI {
    const markup =
      rawPostRFI.markup === null
        ? null
        : (Markup.deserialize(rawPostRFI.markup as RawMarkup) as Markup);

    const originalMarkup =
      rawPostRFI.originalMarkup === null
        ? null
        : (Markup.deserialize(
            rawPostRFI.originalMarkup as RawMarkup
          ) as Markup);

    return new PostRFI({
      ...rawPostRFI,
      markup,
      originalMarkup,
      rfi: RFI.deserialize(rawPostRFI.rfi),
    });
  }

  serialize(): RawPostRFI {
    return this.toJS();
  }
}
